import { Trans, useTranslation } from 'react-i18next';
import { FOUNDER_PHONE_DISPLAY, FOUNDER_PHONE_SMS, FOUNDER_PHONE_TEL } from '@shared/constants/founder-contact.ts';

const linkClass = 'font-medium text-[color:var(--color-brand)] underline';

/**
 * "Questions? Call or text (585) 200-6753."
 *
 * "Call" and the number open the phone dialer. "Text" opens a message.
 * The accessible names include the number ("Call (585) 200-6753") so a
 * screen reader does not hear a bare verb. The number itself lives in one
 * shared constant, interpolated here so a change does not require editing
 * both language files.
 */
export function FounderContactLine({ className }: { className?: string }) {
  const { t } = useTranslation();
  const phone = FOUNDER_PHONE_DISPLAY;
  return (
    <p className={className ?? 'text-sm text-[color:var(--color-muted)]'}>
      <Trans
        i18nKey="founderContact.questions"
        values={{ phone }}
        components={[
          <a
            key="call"
            href={FOUNDER_PHONE_TEL}
            aria-label={t('founderContact.callLabel', { phone })}
            className={linkClass}
          />,
          <a
            key="text"
            href={FOUNDER_PHONE_SMS}
            aria-label={t('founderContact.textLabel', { phone })}
            className={linkClass}
          />,
          <a key="number" href={FOUNDER_PHONE_TEL} className={linkClass} />,
        ]}
      />
    </p>
  );
}
